import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';

import useLenis from '@/hooks/useLenis';
import PromoBar from '@/components/site/PromoBar';
import Header from '@/components/site/Header';
import Hero from '@/components/site/Hero';
import Intro from '@/components/site/Intro';
import Treatments from '@/components/site/Treatments';
import Process from '@/components/site/Process';
import Pricing from '@/components/site/Pricing';
import Team from '@/components/site/Team';
import VideoGallery from '@/components/site/VideoGallery';
import WhyAndReviews from '@/components/site/WhyAndReviews';
import FAQ from '@/components/site/FAQ';
import ParentStudioCTA from '@/components/site/ParentStudioCTA';
import Contact from '@/components/site/Contact';
import Footer from '@/components/site/Footer';

function Home() {
  useLenis();

  return (
    <>
      <div className="sticky top-0 z-50 w-full">
        <PromoBar />
        <Header />
      </div>
      <main>
        <Hero />
        <Intro />
        <Treatments />
        <Process />
        <Pricing />
        <Team />
        <VideoGallery />
        <WhyAndReviews />
        <FAQ />
        <ParentStudioCTA />
        <Contact />
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="bottom-right" />
    </div>
  );
}

export default App;
